<template>
    <USelectMenu
        v-model="modelValue"
        :items="reminderOptions"
        size="lg"
        placeholder="Velg påminnelsestype"
        label-key="name"
        value-key="value"
        class="w-full"
        :ui="{
            content: 'z-50'
        }"
    />
</template>

<script setup lang="ts">
import {KraviaReminder, KraviaReminderEnum, reminderOptions} from '@/debt-collection/KraviaReminder'

const modelValue = defineModel<KraviaReminder>('modelValue', {
    default: KraviaReminderEnum.enum.PAYMENT_REMINDER
})

</script>

<style scoped>

</style>